// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_3L4fxm5XYx0Opt2K2LyGO9","body":"_3dgy1mNPstZXETSNjDZ5Zr","header":"_2c4sFu0f6SSYar1uLS3Q0Z","title":"_3V67tZrnJdzJ8Bw8kv99SJ","subTitle":"_2IVTTA2dUSCrzseDTR5cLS"};